const calculateSocialInsurance = (insuranceWage: number) => {
    return insuranceWage * 0.11;
};

const calculateSocialInsuranceEmployerShare = (insuranceWage: number) => {
    return insuranceWage * 0.1875;
};

export { calculateSocialInsurance, calculateSocialInsuranceEmployerShare };
